import ContentWrapper from "@/components/wrappers/ContentWrapper";
import { Card } from "antd";
import { useTranslation } from "react-i18next";
import BackNavigationArrow from "../../../common/components/views/BackNavigationArrow";
import { AgentForm } from "../components/forms/agent/AgentForm";

export const AgentCreateContainer = () => {
  const { t } = useTranslation();

  return (
    <ContentWrapper>
      <Card
        className="card-box"
        title={
          <BackNavigationArrow>
            <h2>{t("agent.titles.create")}</h2>
          </BackNavigationArrow>
        }
      >
        <AgentForm allowSearch />
      </Card>
    </ContentWrapper>
  );
};
